<template>
  <div class="my-3">
    <label>Select Programs</label>
    <div class="row p-3">
      <div class="col-sm-6 col-md-6 border p-3">
        <label>Select Program</label>
        <b-form-select v-model="Program" :options="ProgramOptions">
          <template #first
            ><option :value="null" disabled
              >-- Please select an option --</option
            ></template
          >
        </b-form-select>
        <b-button
          :to="{
            name:
              Program === 'new'
                ? 'AdminPointProgramsNewProgramContest'
                : 'AdminAddPointsChooseGroupLocation',
            params: { programId: Program },
          }"
          :disabled="!Program"
          variant="primary"
          class="m-3"
          >Next</b-button
        >
      </div>
      <div class="col-sm-6 col-md-6 border p-3">
        <label>Note :</label>
        <ul>
          <li>
            <p
              >This is a list of the programs or contests that are authorized
              for your locations or groups. If you don't see the program or
              contest you are looking for, select New Program from the list and
              click "Next". You will be presented with options for starting a
              new program or contest.</p
            >
          </li>
          <li>
            <p>
              If you just want to add points and you are not interested in using
              a program to do it, choose -Add Points Without a Program or
              Contest- from the list. Your entry will be made without attaching
              the points additions to a program or contest.</p
            >
          </li>
          <li>
            <p>
              Caution: Sometimes a program or contest exists but it is not
              authorized for the location or group that you want. In that case
              click on "manage programs & contests" from the links at the top and
              select the appropriate groups from the list for that
              program.</p
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AddPointsSelectPrograms",

  data() {
    return {
      Program: null,
    };
  },
  computed: {
    ...mapState({
      ProgramOptions: (state) => state.adminAddPoint.Programs,
    }),
  },
  created() {
    this.$store.dispatch("adminAddPoint/fetchPrograms", {
      userId: this.userId,
    });
  },

  methods: {},
};
</script>

<style lang="scss" scoped></style>
